import axios from "../api";
import { CRYPTO_TOKEN_SECRET_KEY } from "../config";
import CryptoJS from "crypto-js";

const getAuthToken = () => {
    const decryptedData = CryptoJS.AES.decrypt(
        localStorage.getItem("token"),
        CRYPTO_TOKEN_SECRET_KEY
    ).toString(CryptoJS.enc.Utf8);
    return decryptedData;
};

export const getMasterUserProfileDetailAction = async () => {
    const authToken = getAuthToken();
    const headers = {
        Authorization: `Bearer ${authToken}`,
    };
    return new Promise((resolve, reject) => {
        axios
            .get(`/api/auth/get-user-profile`, {
                headers: headers,
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const updateMasterUserProfileAction = async (data) => {
    const authToken = getAuthToken();
    const headers = {
        Authorization: `Bearer ${authToken}`,
    };
    return new Promise((resolve, reject) => {
        axios
            .post("/api/auth/change-profile", data, {
                headers: headers,
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error.response.data);
            });
    });
};
